import React from 'react';

import {FilterInput} from 'src/components/input';

import Label from '@pb/kit-component-label';


type Props = {
    email?: string,
    onChange: (email: string) => void,
};

export const EmailFilter = ({email, onChange}: Props) => (
    <div style={{width: 250}}>
        <Label>Email</Label>
        <FilterInput
            id="email-filter"
            value={email || ''}
            placeholder="Email"
            onChange={onChange}
            onClear={() => onChange('')}
            timeOut={10}
        />
    </div>
);
